import { toBits279h5gq970cl4 as toBits } from '../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { toByteArrayce03j8fj9exs as toByteArray } from './Int.ext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toByteArray_0(_this__u8e3s4) {
  return toByteArray(toBits(_this__u8e3s4));
}
//region block: exports
export {
  toByteArray_0 as toByteArray1u8z8rctsleo7,
};
//endregion

//# sourceMappingURL=Float.ext.mjs.map
